export default __webpack_public_path__ + "static/media/edge.06d15d51.png";